export const average = (values: number[]) => (
  values.reduce((sum, current) => sum + current, 0) / values.length
);

export const standardDeviation = (values: number[], av: number) => (
  Math.sqrt(
    values.reduce((sum, current) => sum + (current - av) ** 2, 0) / values.length
  )
);
